import React from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import DropdownHeader from '../DropdownHeader';
import DropdownHeaderText from '../DropdownHeaderText';

function ExportHeader({ text }) {
    return (<DropdownHeader>
        <DropdownHeaderText text={text} />
    </DropdownHeader>)
}

ExportHeader.displayName = displayName('Dropdowns/Export/ExportHeader');

ExportHeader.propTypes = {
    text: PropTypes.string.isRequired,
};

export default ExportHeader;
